import { useInfiniteQuery } from "@tanstack/react-query";

import { useFolderPrivacyStatus } from "../privacy/use-folder-privacy-status";
import { getItemsInfiniteQueryOptions } from "../query-options";
import { useSortBy, useSortOrder } from "../store";
import { useWorkspaceContext } from "../workspace/use-workspace-context";

export function useMineItemsInfiniteQuery() {
  const workspace = useWorkspaceContext();
  const sortBy = useSortBy();
  const sortOrder = useSortOrder();
  const privacyStatus = useFolderPrivacyStatus(workspace.type === "folder" ? workspace.folder_id : undefined);

  return useInfiniteQuery({
    ...getItemsInfiniteQueryOptions({
      workspace,
      sortBy,
      sortOrder,
    }),
    enabled: !privacyStatus.isLoading && !privacyStatus.isLocked,
  });
}
